<template>
  <section :class="$style.uiQuery">
    <template v-if="isLoading">
      <template v-if="loadingType === 'spin'">
        <a-spin>
          <a-icon
            spin
            slot="indicator"
            :class="$style.spinIcon"
            :component="IconWait"
          />
        </a-spin>
      </template>
      <template v-else-if="loadingType === 'skeleton'">
        <a-skeleton active :paragraph="{ rows: 5 }" :title="false" />
        <a-skeleton active :paragraph="{ rows: 5 }" :title="false" />
        <a-skeleton active :paragraph="{ rows: 5 }" :title="false" />
      </template>
      <template v-else>
        <a-spin>
          <a-icon slot="indicator" :component="IconWait" spin />
        </a-spin>
      </template>
    </template>
    <template v-else>
      <slot />
    </template>
  </section>
</template>

<script>
import { Skeleton, Spin, Icon } from "ant-design-vue";
import IconWait from "@/assets/img/common/icon-wait.svg?inline";

export default {
  name: "UIQuery",
  props: {
    isLoading: {
      type: [Boolean],
      default: true
    },
    loadingType: {
      type: [String],
      default: "spin" // spin | skeleton
    }
  },
  data() {
    return {
      IconWait
    };
  },
  computed: {},
  components: {
    [Icon.name]: Icon,
    [Spin.name]: Spin,
    [Skeleton.name]: Skeleton
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style lang="scss" module>
@import "~rfs/scss";

.uiQuery {
  .spinIcon {
    @include rfs(3rem);
  }
  // :global {
  //   .ant-spin .ant-spin-spinning .ant-spin-dot {
  //     @include rfs(3rem);
  //   }
  // }
}
</style>
